import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '../views/Dashboard';
import Signin from '../views/Signin';
import Registration from '../views/Registration';

import VerificationEmail from '../views/VerificationEmail';

import ForgotPassword from '../views/ForgotPassword';
import ChangePassword from '../views/ChangePassword';
import ChangePasswordUser from '../views/ChangePasswordUser';

import Home from '../views/Home';
import TopUp from '../views/TopUp';
import Success from '../views/Success';
import Checkout from '../views/Checkout';
import Subscribe from '../views/Subscribe';
import SubscriptionCheckout from '../views/SubscriptionCheckout';
import SubscriptionSuccess from '../views/SubscriptionSuccess';
import TransactionFailed from '../views/TransactionFailed';
import TransactionSuccess from '../views/TransactionSuccess';
import DonationLists from '../views/DonationLists';
import Donations from '../views/Donations';
import DonationsSuccess from '../views/DonationsSuccess';
import DonationPage from '../views/DonationPage';
import SurveyPage from '../views/SurveyPage';
import PremiumPage from '../views/PremiumPage';
import MobileAppPage from '../views/MobileApp';
import ChangeSubscriptionPage from '../views/ChangeSubscription';
import ChangeSubscriptionSuccessPage from '../views/ChangeSubscriptionSuccess';
import UpdatePaymentPage from '../views/UpdatePayment';
import DirectSubscribe from '../views/DirectSubscribe';
import TestPage from '@/views/TestPage';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/home',
    name: 'Dashboard',
    component: Dashboard,
    children: [
      {
        path: '/change-password-user',
        name: 'ChangePasswordUser',
        component: ChangePasswordUser,
      }, {
        path: '/home',
        name: 'HomePage',
        component: Home,
      }, {
        path: '/top-up',
        name: 'TopUpPage',
        component: TopUp,
      }, {
        path: '/success',
        name: 'SuccessPage',
        component: Success,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/checkout',
        name: 'CheckoutPage',
        component: Checkout,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/subscription',
        name: 'SubscribePage',
        component: Subscribe,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/subscription-checkout',
        name: 'SubscriptionCheckoutPage',
        component: SubscriptionCheckout,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/subscription-success',
        name: 'SubscriptionSuccessPage',
        component: SubscriptionSuccess,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/transaction-failed',
        name: 'TransactionFailedPage',
        component: TransactionFailed,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/transaction-success',
        name: 'TransactionSuccessPage',
        component: TransactionSuccess,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/donation-lists',
        name: 'DonationListsPage',
        component: DonationLists,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/donations',
        name: 'DonationsPage',
        component: Donations,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/donation-success',
        name: 'DonationsSuccessPage',
        component: DonationsSuccess,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/change-subscription',
        name: 'ChangeSubscriptionPage',
        component: ChangeSubscriptionPage,
        props: route => Object.assign({}, route.query, route.params),
      }, {
        path: '/change-subscription-success',
        name: 'ChangeSubscriptionSuccessPage',
        component: ChangeSubscriptionSuccessPage,
        props: route => Object.assign({}, route.query, route.params),
      },
    ],
  },
  {
    path: '/login',
    name: 'Signin',
    component: Signin,
  },
  {
    path: '/verify-email',
    component: VerificationEmail,
    props: route => Object.assign({}, route.query, route.params),
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    name: 'ForgotPassword',
    props: route => Object.assign({}, route.query, route.params),
  },
  {
    path: '/change-password',
    component: ChangePassword,
    name: 'ChangePassword',
    props: route => Object.assign({}, route.query, route.params),
  }, {
    path: '/register',
    name: 'Registration',
    component: Registration,
  }, {
    path: '/donation-page',
    name: 'DonationPageAnon',
    component: DonationPage,
  }, {
    path: '/survey',
    name: 'SurveyPage',
    component: SurveyPage,
    props: route => Object.assign({}, route.query, route.params),
  }, {
    path: '/premium',
    name: 'PremiumPage',
    component: PremiumPage,
    props: route => Object.assign({}, route.query, route.params),
  }, {
    path: '/mobile-app',
    name: 'MobileAppPage',
    component: MobileAppPage,
  },
  {
    path: '/update-payment',
    name: 'UpdatePaymentPage',
    component: UpdatePaymentPage,
  },
  {
    path: '/update-payment-success',
    name: 'UpdatePaymentSuccessPage',
    component: UpdatePaymentPage,
  },
  {
    path: '/update-payment-failed',
    name: 'UpdatePaymentFailedPage',
    component: UpdatePaymentPage,
  },
  {
    path: '/direct-subscribe',
    name: 'DirectSubscribePage',
    component: DirectSubscribe,
  },
  {
    path: '/test-page',
    name: 'TestPage',
    component: TestPage,
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    '/login',
    '/register',
    '/verify-email',
    '/signup-success',
    '/forgot-password',
    '/change-password',
    '/send-verification',
    '/donation-page',
    '/premium',
    '/mobile-app',
    '/update-payment',
    '/update-payment-success',
    '/update-payment-failed',
    '/direct-subscribe',
    '/test-page',
  ];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('access_token');
  if (authRequired && !loggedIn) {
    return next('/login');
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js